module.exports = __webpack_public_path__ + "public/images/2023_Evergreen_FacebookPost.6bfacfa7b4a8d2ebd7479012540215e6.jpg";